import { createContext } from "react";

export declare type AuthContext = {
  name: string;
  logout: () => void;
};

export const authContext = createContext<AuthContext | undefined>(undefined);

